// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"aff39374","337":"5ddf1975","766":"d32f74a3","970":"8a5021fe"}[chunkId] + ".chunk.js";
};